import { withTexts } from '../with-texts';
import { 
  CodeSelectorTileView as UICodeSelectorTileView
} from 'app/components';

import {
  ReferenceSelectTileView as UIReferenceSelectTileView
} from  'app/area/case/components/reference-select-tile-view';

const codeSelectorTileViewTexts = {
  textOptionsDone: 7338,
  textOptionsNotFound: 7644,
  textOptionsLoadError: 7524,
  textSearchRequired: 8146,
  textSearchRequiredExceedsMaxResult: 8625,
  textPageOf: 8454,
  textSelectAll: 8420,
  textClearAll: 8421,

  textDone: 7338
};

export const CodeSelectorTileView = withTexts(codeSelectorTileViewTexts)(UICodeSelectorTileView);
export const ReferenceSelectTileView = withTexts(codeSelectorTileViewTexts)(UIReferenceSelectTileView);
